import {
  CLEAN_DETAIL_TRANSACTIONS_YUNO,
  CLEAN_DETAIL_TRANSACTIONS_YUNO_ERROR,
} from '_models/redux/types';

export const cleanDetailYunoAction = () => async (dispatch) => {
  try {
    dispatch({
      payload: undefined,
      type: CLEAN_DETAIL_TRANSACTIONS_YUNO,
    });
  } catch {
    dispatch({
      payload: undefined,
      type: CLEAN_DETAIL_TRANSACTIONS_YUNO_ERROR,
    });
  }
};
